import { Box, Icon, Typography } from '@drone-js/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { selectScreenSize } from 'store/slice/screen';

interface NearMeCompProps {
    onClick: () => void;
}

const NearMeTemplate: React.FC<NearMeCompProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const isSearchBoxFeatureGroup = useSelector(selectFeatureBehaviorFromBootstrap).SearchBoxFeatureGroup;
    const isSearchBoxPopOverFeature = useSelector(selectFeatureBehaviorFromBootstrap).SearchBoxPopOverFeature;

    const screenSize = useSelector(selectScreenSize);
    const { desktop: isDesktop, mobile: isMobile } = screenSize;
    const showOldDesign = !isSearchBoxFeatureGroup;
    const isSearchBoxPopOverFeatureDesktop = isSearchBoxPopOverFeature && isDesktop;
    const paddingX = isSearchBoxPopOverFeatureDesktop ? '0' : showOldDesign ? (isMobile ? '12' : '8') : '0';
    const rootContainerPaddingX = isSearchBoxFeatureGroup
        ? isMobile
            ? '12'
            : isSearchBoxPopOverFeature
              ? '4'
              : '16'
        : isSearchBoxPopOverFeature
          ? isMobile && !isSearchBoxFeatureGroup
              ? '16'
              : '12'
          : '4';

    return (
        <Box p="4" pb="0" px={rootContainerPaddingX} mb="0" mt={isSearchBoxFeatureGroup && isMobile ? '0' : '12'} width="100%" maxWidth="744px" mx="auto">
            <Box px={paddingX} pb="0" data-element-name="activities-overlay-text-near-me-item-outer-cont">
                <Box
                    as="button"
                    px={isSearchBoxFeatureGroup && isDesktop ? '4' : '8'}
                    py={showOldDesign ? '16' : '8'}
                    borderRadius="8"
                    onClick={props.onClick}
                    display="flex"
                    flexDirection="row"
                    data-testid="activities-overlay-text-near-me-item"
                    data-element-name="activities-overlay-text-near-me-item"
                    interactive="product.primary"
                    textAlign="start"
                    width="100%"
                >
                    {showOldDesign ? (
                        <>
                            <Icon id="fill.symbol.navigate" size="24" color="product.primary" me="12" />
                            <Typography variant="body-default-strong">{cms[310622]}</Typography>
                        </>
                    ) : (
                        <>
                            <Box width="48px" height="48px" backgroundColor="base.background" borderRadius="8" display="flex" justifyContent="center" alignItems="center">
                                <Icon id="fill.symbol.navigate" size="20" />
                            </Box>
                            <Box height="48px" ps="12" display="flex" flexDirection="row" alignItems="center" textAlign="left" gap="4">
                                <Typography variant="body-default-strong">{cms[310622]}</Typography>
                            </Box>
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
NearMeTemplate.displayName = 'NearMeComponent';
export default NearMeTemplate;
